import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { ConfirmOptionsModel } from './typings/confirm.options';

@Component({
  selector   : 'confirmation-generic',
  template: require('./confirmation.generic.component.html')
})
export class ConfirmationGenericComponent {
  @Input() message: string;
  @Input() options: ConfirmOptionsModel;
  @Input() type   : string;

  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
